import { useEffect, useState } from "react";

function ToTopBtn() {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsActive(window.pageYOffset > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    return (
        <div className="bottom-to-top">
            <a
                href="#"
                className={`to-top ${isActive ? "active" : ""}`}
                onClick={scrollToTop}
            >
                <span className="fa-solid fa-arrow-up to-top-icon"></span>
            </a>
        </div>
    )
}

export default ToTopBtn